module.exports = __webpack_public_path__ + "img/bj28.b33c45bf.png";